import { render, staticRenderFns } from "./TransportadoraTpCalc.vue?vue&type=template&id=c02bf86a"
import script from "./TransportadoraTpCalc.vue?vue&type=script&lang=js"
export * from "./TransportadoraTpCalc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports